// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'minus';

export const Component = () => (
  <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' d='M2 9h13' />
);

export const viewBox = '0 0 18 18';
